import { combineReducers } from 'redux'
import { addressReducer as address } from './Address/addressReducer'
import { cartDetailsReducer as details } from './CartDetails/cartDetailsReducer'
import { paymentReducer as payment } from './Payment/paymentReducer'

export const cartReducer = combineReducers({
  details,
  address,
  payment,
})

export const getCartItems = state => state.cart.details.items
export const getIsCartInitialised = state => state.cart.details.isCartInitialised
export const getisCartReviewed = state => state.cart.details.isCartReviewed
export const getisCartCompleted = state => state.cart.details.isCartCompleted
export const getisCartProcessing = state => state.cart.details.isCartProcessing
export const getisAddressValidated = state => state.cart.address.isAddressValidated
export const getSubTotal = state => state.cart.details.subTotal
export const getTax = state => state.cart.details.taxes
export const getEntitlement = state => state.cart.details.entitlement
export const getActiveCartTab = state => state.cart.details.activeTab
export const getAddress = state => state.cart.address.shipping
export const getPayment = state => state.cart.payment.details
export const getMatchedAddresses = state => state.cart.address.matchedAddresses
export const getIsCartDocked = state => state.cart.details.isCartDocked



// WEBPACK FOOTER //
// ./src/containers/Cart/cartReducer.js